import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sonarr = defineConnector({
  identifier: "sonarr",
  name: "Sonarr",
  tagLine: "TV series management and automation",
  logo,
  protocol: "http",
  tags: ["data"],
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Sonarr, go to **Settings → General** and copy the API key.",
        },
      ],
    },
    {
      title: "Enter your Sonarr details",
      items: [
        {
          kind: "url",
          label: "Sonarr server URL",
          required: true,
          placeholder: "https://sonarr.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Sonarr instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v3/system/status`,
  },
});
